import { Maximize2, Minimize2, Phone, ShieldCheck, Video, X } from "lucide-react";
import { Sparkles } from "lucide-react";

interface ChatHeaderProps {
  expanded: boolean;
  onToggleExpand: () => void;
  onClose: () => void;
  onVoiceCall: () => void;
  onVideoCall: () => void;
  isVerified?: boolean;
  translateTo: string;
  onTranslateChange: (val: string) => void;
  autoTranslate: boolean;
  onAutoTranslateToggle: () => void;
  languages: readonly { readonly code: string; readonly label: string; readonly flag: string }[];
}

const ChatHeader = ({
  expanded, onToggleExpand, onClose, onVoiceCall, onVideoCall,
  isVerified = true, translateTo, onTranslateChange, autoTranslate,
  onAutoTranslateToggle, languages,
}: ChatHeaderProps) => {
  return (
    <div className="flex items-start justify-between gap-3 px-4 py-3 border-b border-border bg-secondary/30">
      <div className="flex items-start gap-2 min-w-0">
        <div className="w-7 h-7 rounded-full bg-sovereign-gold/20 flex items-center justify-center flex-shrink-0">
          <Sparkles className="w-3.5 h-3.5 text-sovereign-gold" />
        </div>
        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            <p className="text-xs font-bold">The Floor Chatbot</p>
            {isVerified && (
              <span className="inline-flex items-center gap-0.5 rounded-full bg-ai-cyan/10 border border-ai-cyan/20 px-1.5 py-0.5 text-[8px] font-mono text-ai-cyan">
                <ShieldCheck className="w-2.5 h-2.5" /> Verified
              </span>
            )}
          </div>
          <p className="text-[9px] text-muted-foreground font-mono">THE FLOOR AI • AUTO-TRANSLATE</p>
          <div className="flex flex-wrap items-center gap-1.5 mt-2">
            <select value={translateTo} onChange={(e) => onTranslateChange(e.target.value)} className="h-7 rounded-md border border-border bg-background px-2 text-[10px] text-foreground">
              <option value="">No translation</option>
              {languages.map((lang) => (<option key={lang.code} value={lang.code}>{lang.flag} {lang.label}</option>))}
            </select>
            <button onClick={onAutoTranslateToggle} disabled={!translateTo}
              className={`h-7 rounded-full border px-2.5 text-[10px] font-mono transition-colors ${autoTranslate && translateTo ? "border-ai-cyan/30 bg-ai-cyan/10 text-ai-cyan" : "border-border text-muted-foreground disabled:opacity-50"}`}
            >AUTO {autoTranslate && translateTo ? "ON" : "OFF"}</button>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <button onClick={onVoiceCall} className="p-1.5 rounded-lg hover:bg-secondary text-muted-foreground hover:text-sovereign-gold transition-colors" title="Voice Call">
          <Phone className="w-3.5 h-3.5" />
        </button>
        <button onClick={onVideoCall} className="p-1.5 rounded-lg hover:bg-secondary text-muted-foreground hover:text-ai-cyan transition-colors" title="Video Call">
          <Video className="w-3.5 h-3.5" />
        </button>
        <button onClick={onToggleExpand} className="p-1.5 rounded-lg hover:bg-secondary text-muted-foreground">
          {expanded ? <Minimize2 className="w-3.5 h-3.5" /> : <Maximize2 className="w-3.5 h-3.5" />}
        </button>
        <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-secondary text-muted-foreground">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
